"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = SpinRtb;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function SpinRtb({
  rtb = '',
  classNames
}) {
  return /*#__PURE__*/_react.default.createElement("span", {
    "data-testid": "spin-rtb",
    "data-cy": "spin-rtb",
    className: classNames
  }, rtb);
}
SpinRtb.propTypes = {
  classNames: _propTypes.default.string,
  rtb: _propTypes.default.string
};